// src/components/strumenti/OreMinuti.js — W442. Somma di ore e minuti; ore decimali ↔ ore:minuti
import React from "react";
import { useCampi, Testo, Campo, Modi, Risultato, Formula, Azzera, Avviso, fmt } from "./UiStrumento";
import { minutiDaTesto, testoDaMinuti } from "../../utils/calcoliStrumenti";

export default function OreMinuti() {
  const { v, set, azzera, setV } = useCampi({ modo:"somma", testo:"", singolo:"" });
  const righe = String(v.testo || "").split("\n").map(r => r.trim()).filter(Boolean);
  const minuti = righe.map(minutiDaTesto);
  const errate = minuti.map((m, i) => (m === null ? i + 1 : null)).filter(Boolean);
  const tot = righe.length && !errate.length ? minuti.reduce((t, m) => t + m, 0) : null;
  const uno = minutiDaTesto(v.singolo);
  return (
    <div>
      <Modi settore="matematica" valore={v.modo} onChange={(m) => setV(o => ({ ...o, modo:m }))} opzioni={[["somma", "Somma ore"], ["converti", "Decimali ↔ ore:minuti"]]}/>
      {v.modo === "somma" ? (
        <>
          <div style={{ marginBottom:12 }}>
            <Testo etichetta="Ore, una per riga" valore={v.testo} onChange={set("testo")} placeholder={"7:30\n8:15\n-0:30   (per sottrarre)\n6,5     (ore decimali)"} righe={6} aiuto="Scrivi «7:30» (ore:minuti) oppure «7,5» (ore decimali). Il segno meno sottrae."/>
          </div>
          {errate.length > 0 && <Avviso>Righe non lette: {errate.join(", ")} (i minuti vanno da 0 a 59).</Avviso>}
          <Risultato settore="matematica" titolo="Totale" valore={tot === null ? "—" : testoDaMinuti(tot)} unita="h:mm"
            righe={tot === null ? [] : [["In ore decimali", fmt(tot / 60, 2) + " h"], ["In minuti", fmt(tot, 0) + " min"], ["In giornate da 8 ore", fmt(tot / 480, 2)]]}/>
        </>
      ) : (
        <>
          <div style={{ marginBottom:12 }}>
            <Campo etichetta="Ore (scrivi «7:45» oppure «7,75»)" valore={v.singolo} onChange={set("singolo")} placeholder="Es. 7:45"/>
          </div>
          <Risultato settore="matematica" titolo="Conversione" valore={uno === null ? "—" : `${testoDaMinuti(uno)} = ${fmt(uno / 60, 4)} h`}
            righe={uno === null ? [] : [["Minuti", fmt(uno, 0)]]}/>
        </>
      )}
      <Formula>Ore decimali = ore + minuti ÷ 60 (7:45 = 7,75 h). Il totale può superare le 24 ore (es. ore di un mese). Arrotondamento al minuto.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
